<template>
  <div>
    <div style="padding: 10px 10px">
      <div style="text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 10px">筛选条件</div>
      <template v-if="!history">
        <template v-if="delivery">
          <div style="margin: 16px 12px 4px; font-size: 14px">交车日期</div>
          <check-button-group v-model="filters.deliveryDays" v-if="delivery">
            <check-button v-for="item of filters.deliveryDayList" :label=item.delta :text="item.name" :key="item.name"
                          style="display: inline-block; margin: 4px 10px;"></check-button>
          </check-button-group>
        </template>
        <template v-else>
          <div style="margin: 16px 12px 4px; font-size: 14px">工序</div>
          <check-button-group v-model="filters.procedureIds">
            <check-button v-for="procedure in $store.state.data.ActiveMiddleProcedure" :key="procedure.id"
                          :label="procedure.id" :text="procedure.name" style="display: inline-block; margin: 4px 8px">
            </check-button>
          </check-button-group>
          <div style="margin: 16px 12px 4px; font-size: 14px">单据状态</div>
          <check-button-group v-model="filters.states">
            <check-button v-for="(state, key, index) in filters.allStates" :key="index"
                          :label="key" :text="state" style="display: inline-block; margin: 4px 8px">
            </check-button>
          </check-button-group>
          <div style="margin: 16px 12px 4px; font-size: 14px">车辆状态</div>
          <check-button-group v-model="filters.carstates">
            <check-button v-for="(carstate, key, index) in filters.allCarstates" :key="index"
                          :label="key" :text="carstate" judge="radio" style="display: inline-block; margin: 4px 8px">
            </check-button>
          </check-button-group>
          <div style="margin: 16px 12px 4px; font-size: 14px">交车日期</div>
          <check-button-group v-model="filters.deliveryDays">
            <check-button :label=-1 text="昨日" style="display: inline-block; margin: 4px 10px;"></check-button>
            <check-button :label=0 text="今日" style="display: inline-block; margin: 4px 10px"></check-button>
            <check-button :label=1 text="明日" style="display: inline-block; margin: 4px 10px"></check-button>
          </check-button-group>
        </template>
      </template>

      <!-- history -->
      <template v-else>
        <label style="margin: 16px 12px 4px;">开单日期</label>
        <label class="value" @click="openDateTimePicker">
          <span v-if="filters.enterDate">{{filters.enterDate}}</span>
          <span v-else style="color: orange">请选择</span>
        </label>
        <van-popup v-model="showDateDatePicker" position="bottom" style=" height: 60%">
          <van-datetime-picker
            v-model="editEnterDate"
            type="date"
            title="选择开单时间"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="confirmEnterDate"
            @cancel="cancelEnterDate">
          </van-datetime-picker>
        </van-popup>
      </template>

      <div v-if="!$isTechnician()"
           style="margin: 16px 12px 4px; font-size: 14px; height: 22px; line-height: 22px; display: flex">
        <label style="flex-shrink: 0">技师</label>
        <van-tag type="primary" closeable v-for="(id, index) of filters.technicianIds" :key="index"
                 style="margin-left: 10px;"
                 @close="closeTag(0, index)">
          {{technicianMap[id]}}
        </van-tag>
        <van-button round size="mini" icon="plus" type="info" style="margin-left: 10px; height: 22px;"
                    @click="openPickTechnician"></van-button>
      </div>
      <div v-if="!$isTechnician()"
           style="margin: 16px 12px 4px; font-size: 14px; height: 22px; line-height: 22px; display: flex">
        <label style="flex-shrink: 0">工组</label>
        <van-tag type="primary" closeable v-for="(id, index) of filters.teamIds" :key="index"
                 style="margin-left: 10px;"
                 @close="closeTag(2, index)">
          {{teamMap[id]}}
        </van-tag>
        <van-button round size="mini" icon="plus" type="info" style="margin-left: 10px; height: 22px;"
                    @click="openPickTeam"></van-button>
      </div>
      <div v-if="!isConsultant"
           style="margin: 16px 12px 4px; font-size: 14px; height: 22px; line-height: 22px; display: flex">
        <label style="flex-shrink: 0">顾问</label>
        <van-tag type="primary" closeable v-for="(id, index) of filters.consultantIds" :key="index"
                 style="margin-left: 10px;"
                 @close="closeTag(1, index)">
          {{consultantMap[id]}}
        </van-tag>
        <van-button round size="mini" icon="plus" type="info" style="margin-left: 10px; height: 22px;"
                    @click="openPickConsultant"></van-button>
      </div>
    </div>
    <div style="width: 100%; display: flex; justify-content: center; margin-top: 8px">
      <van-button style="width: 40%; height: 40px; font-size: 16px" size="small" @click="resetFilters">重置</van-button>
      <van-button style="width: 40%; height: 40px; font-size: 16px" size="small" type="primary"
                  @click="$emit('update:show', false)">完成
      </van-button>
    </div>
    <van-popup v-model="picker.show" position="bottom" style="height: 60%;" round safe-area-inset-bottom>
      <van-picker
        :title="pickerTitle"
        show-toolbar
        :columns="pickerColumns"
        @confirm="onSelect"
        @cancel="picker.show = false">
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
  import { Button, DatetimePicker, Picker, Popup, Tag } from 'vant'
  import CheckButtonGroup from '@/views/wx/CheckButtonGroup'
  import CheckButton from '@/views/wx/CheckButton'
  import { technicianList } from '@/utils/request'
  import { checkHasPosition } from '@/utils/auth-directive'

  export default {
    name: 'WxWorkListFilter',
    components: {
      CheckButton,
      CheckButtonGroup,
      [Button.name]: Button,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [Tag.name]: Tag,
      [DatetimePicker.name]: DatetimePicker
    },
    props: {
      show: Boolean,
      filters: {
        type: Object,
        required: true
      },
      history: Boolean,
      delivery: Boolean
    },
    data () {
      return {
        picker: {
          type: null, // 0 技师, 1 顾问, 2 工组
          show: false,
          columns: []
        },
        technicianList: [],
        teamList: [],
        showDateDatePicker: false,
        editEnterDate: null
      }
    },
    mounted () { },
    methods: {
      resetFilters () {
        this.filters.procedureIds = []
        this.filters.states = []
        this.filters.carstates = []
        this.filters.deliveryDays = []
        this.filters.technicianIds = []
        this.filters.consultantIds = []
        this.filters.teamIds = []
        this.filters.enterDate = null
      },
      openPickTechnician () {
        this.picker.type = 0
        this.picker.olumns = []
        this.picker.show = true
        technicianList().then(response => {
          this.technicianList = response.data
          this.picker.columns = response.data.map(item => {
            return {
              id: item.id,
              text: item.name
            }
          })
        })
      },
      openPickConsultant () {
        this.picker.type = 1
        this.picker.columns = []
        this.picker.show = true
        this.$store.dispatch('data/kvListForce', 'ConsultantsOfShop').then(shops => {
          for (const shop of shops || []) {
            for (const consultant of shop.consultants || []) {
              this.picker.columns.push({
                id: consultant.id,
                text: consultant.name
              })
            }
          }
        })
      },
      openPickTeam () {
        this.picker.type = 2
        this.picker.columns = []
        this.picker.show = true
        this.$store.dispatch('team/all').then(teamList => {
          this.teamList = teamList
          this.picker.columns = teamList.map(item => {
            return {
              id: item.id,
              text: item.name
            }
          })
        })
      },
      onSelect (value) {
        if (!value) return
        this.picker.show = false
        this.filterIdsByType(this.picker.type).push(value.id)
      },
      closeTag (type, index) {
        this.filterIdsByType(type).splice(index, 1)
      },
      filterIdsByType (type) {
        switch (type) {
          case 0:
            return this.filters.technicianIds

          case 1:
            return this.filters.consultantIds

          default:
            return this.filters.teamIds
        }
      },
      openDateTimePicker () {
        if (!this.filters.enterDate) {
          this.editEnterDate = new Date()
        } else {
          this.editEnterDate = this.filters.enterDate
        }
        this.showDateDatePicker = true
      },
      confirmEnterDate () {
        this.filters.enterDate = new Date(this.editEnterDate).format('yyyy-MM-dd')
        this.showDateDatePicker = false
      },
      cancelEnterDate () {
        this.showDateDatePicker = false
      }
    },
    computed: {
      pickerTitle () {
        switch (this.picker.type) {
          case 0:
            return '选择技师'
          case 1:
            return '选择顾问'
          default:
            return '选择工组'
        }
      },
      technicianMap () {
        if (!this.technicianList) return {}
        const ret = {}
        for (const technician of this.technicianList) {
          ret[technician.id] = technician.name
        }
        return ret
      },
      teamMap () {
        if (!this.teamList) return {}
        const ret = {}
        for (const team of this.teamList) {
          ret[team.id] = team.name
        }
        return ret
      },
      consultantMap () {
        const ret = {}
        const consultants = this.$store.state.data.ConsultantsOfShop
        for (const shop of consultants || []) {
          for (const consultant of shop.consultants || []) {
            ret[consultant.id] = consultant.name
          }
        }
        return ret
      },
      pickerColumns () {
        const ids = this.filterIdsByType(this.picker.type)
        return this.picker.columns.filter(item => ids.indexOf(item.id) === -1)
      },
      isConsultant () {
        return checkHasPosition('CONSULTANT_PO')
      },
      minDate () {
        const date = new Date()
        date.setTime(date.getTime() - 365 * 5 * 24 * 60 * 60 * 1000)
        return date
      },
      maxDate () {
        return new Date()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .value {
    display: inline-block;
    color: black;
    margin-left: 34px;
  }
</style>
